<template></template>

<script>
export default {
  name: "logout",
  created() {
      localStorage.removeItem("swmLSuser");
      location = "/login";
  }
};
</script>
